<template>
  <Layout>
    <PageHeader />
    <div
      class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
    >
      <h5 class="card-title mb-0">Inscricao de Time</h5>
    </div>
    <div class="card-body">
      <InscricaoTime />
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import InscricaoTime from '@/components/inscricao/InscricaoTime.vue'

export default {
  name: 'Inscricao',

  components: {
    Layout,
    PageHeader,
    InscricaoTime,
  },

  data() {
    return {
      title: 'Inscrição de Time',
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },
}
</script>
